"use strict";

var __assign = this && this.__assign || Object.assign || function (t) {
  for (var s, i = 1, n = arguments.length; i < n; i++) {
    s = arguments[i];

    for (var p in s) {
      if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
  }

  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var hs_web_style_guide_1 = require("@headspace/hs-web-style-guide");

exports.tableCellStyle = hs_web_style_guide_1.css({
  display: 'flex',
  flexDirection: 'row',
  flexGrow: 1,
  flexBasis: 0,
  justifyContent: 'space-between',
  alignItems: 'center',
  minWidth: 0,
  marginRight: 32,
  ' *': {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    wordBreak: 'break-word'
  },
  ':last-of-type': {
    marginRight: 0
  }
});

function BasicTableCell(props) {
  var children = props.children;
  return React.createElement("div", __assign({
    className: "basicTableCell"
  }, props, exports.tableCellStyle), React.createElement("div", null, children));
}

exports.BasicTableCell = BasicTableCell;